import React from 'react';
import Webcam from "react-webcam";
import whiteboard from '../images/whiteboard.jpg';
import Popup from 'reactjs-popup';

import './WhiteBoard.css';

function WhiteBoard() {
    return (
      <div className="App">
        <Popup
    trigger={<button className="button"> Instructions </button>}
    modal
    nested
    defaultOpen
  >
    {close => (
      <div className="modal">
        <div className="header"> <strong> Whiteboard Simulator </strong> </div>
        <div className="content">
          {' '}
          This application utilizes a trained AI to track your arm's movements across the screen using the webcam, in order to draw
            exactly where you do in the real world. 
            <br/>
            <br/>This allows for any device to effectively have a touchscreen-driven art program. <br/>
            For this simulation, you will need a dry erase marker, and a method of removing dry erase marks.
        </div>
        <div className="actions">
          <button
            className="button"
            onClick={() => {
              console.log('modal closed ');
              close();
            }}
          >
            Let's Get Started!
          </button>
        </div>
      </div>
    )}
  </Popup>



        <div class = "whiteboardContainer">
        <img src={whiteboard} style={{width:'100%', height:'100%'}}
              alt="a whiteboard you can draw on once you obtain a dry-erase marker" />
        <div class = "fadeInstructions" id = "instructions">

          </div>
        </div>
      </div>
    );
}
  
  export default WhiteBoard;
  